import React, { useEffect, useState } from 'react'
import { Input, Form } from "antd";
import ModalComponent from "../../../components/global/modal/ModalComponent";
import toast from "react-hot-toast";
import { ChangeCRMPasswordApi } from "../../../api/request/client"
import LoadableButton from "../../../components/buttons/LoadableButton.jsx";

function ChangePassword({ changePasswor, setChangePassword, id, updateData }) {

  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [initialValues, setInitialValues] = useState({ newPassword: '', confirmPassword: '' });

  const handleSubmit = async (values) => {
    try {
      setIsLoading(true)
      let params = {
        userId: id,
        newPassword: values?.newPassword
      }
      const { data } = await ChangeCRMPasswordApi(params);
      if (data?.success) {
        updateData();
        form?.resetFields();
        setChangePassword(false);
      }
      setIsLoading(false)
    } catch (error) {
      if (error?.response?.data?.message) {
        toast.error(error?.response?.data?.message);
      }
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (!changePasswor) {
      form?.resetFields();
    }
  })

  return (
    <div>
      <ModalComponent isOpen={changePasswor} setIsOpen={setChangePassword} title="Change Password" width={600}>
        <Form autoComplete="off" form={form} initialValues={initialValues} onFinish={handleSubmit}>
          <div className='input-white'>
            <label className='text-base text-[#2F2B3DCC] font-medium'>New Password</label>
            <Form.Item name='newPassword' hasFeedback rules={[{ required: true, message: 'Please enter new password.' }, {
              pattern: /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,}$/,
              message: 'Please enter strong password.',
            },]}>
              <Input.Password type='password' placeholder="New password" className="mt-1 w-full ps-4 py-2" />
            </Form.Item>
          </div>
          <div className='input-white mt-5'>
            <label className='text-base text-[#2F2B3DCC] font-medium'>Confirm Password</label>
            <Form.Item name='confirmPassword' dependencies={['newPassword']} hasFeedback rules={[{ required: true, message: 'Please enter confirm password.' }, ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue('newPassword') === value) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error('The new password that you entered do not match!'));
              },
            }),]}>
              <Input.Password type='password' placeholder="Confirm password" className="mt-1 w-full ps-4 py-2" />
            </Form.Item>
          </div>
          <div className='flex justify-between items-center gap-5 flex-wrap mt-6'>
            <div className="flex gap-5">
              <button type='button' onClick={() => setChangePassword(false)} className='bg-primary text-sm text-white font-semibold rounded-lg px-6 py-2 uppercase themeHover duration-500'>Cancel</button>
              <LoadableButton
                type='submit' className='bg-primary text-sm text-white font-semibold rounded-lg px-12 py-2 uppercase themeHover duration-500'
                disabled={isLoading}
                lable="Submit"
                isLoading={isLoading}
                loadingLable="Send Credentials..."
              />
            </div>
          </div>
        </Form>
      </ModalComponent>
    </div>
  )
}

export default ChangePassword
